var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGripHorizontalThreeLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,7H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3,11H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3,15H21a1,1,0,0,0,0-2H3a1,1,0,0,0,0,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGripHorizontalThreeLines);
export default __webpack_public_path__ + "static/media/grip_horizontal_three_lines.97cabfbe006a07853ddb89649a92c9ca.svg";
export { ForwardRef as ReactComponent };